import React from "react";

function InvestmentTiers() {
  return (
    <section className="feature_section home_five">
      <div className="container">
        <div className="row">
          <div className="section_title centred">
            <h2>Investment Tiers</h2>
            <p>
              Account Handling Services, Portfolio Management Services & Private
              Placement Programme are available across multiple <br />
              investment levels in India and worldwide.
            </p>
          </div>

          {/* MT4 Platforms */}
          <div className="col-xl-5 col-lg-6 col-md-12">
            <div
              className="feature_block_one"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="100"
            >
              <h3>MT4 Platforms</h3>
              <p>
                Advanced trading platform with powerful analysis tools and
                automated trading capabilities.
              </p>
              <div className="chart_box">
                <img
                  src="/images/resource/digitalpayment (1).jpg"
                  alt="MT4 Platforms"
                />
              </div>
            </div>
          </div>

          {/* MT5 Platforms */}
          <div className="col-xl-7 col-lg-6 col-md-12">
            <div
              className="feature_block_one"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="550"
              data-aos-delay="200"
            >
              <h3>MT5 Platforms</h3>
              <p>
                Next-generation trading platform with enhanced features for
                multiple asset classes.
              </p>
              <div className="chart_box">
                <img
                  src="/images/resource/fraudDetection.jpg"
                  alt="MT5 Platforms"
                  style={{ height: "265px", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>

          {/* VPS Algo Setup */}
          <div className="col-xl-7 col-lg-6 col-md-12">
            <div
              className="feature_block_one"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="550"
              data-aos-delay="300"
            >
              <h3>VPS Algo Setup</h3>
              <p>
                Virtual Private Server solutions for uninterrupted algorithmic
                trading.
              </p>
              <div className="chart_box">
                <img
                  src="/images/resource/vps-algo-setup.jpg"
                  alt="VPS Algo Setup"
                  style={{ height: "295px", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>

          {/* Account Handling */}
          <div className="col-xl-5 col-md-12 col-sm-12">
            <div
              className="feature_block_one style_two"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="600"
              data-aos-delay="400"
            >
              <div className="row">
                <div className="col-xl-12">
                  <h3>Account Handling</h3>
                  <p>
                    Professional management of your trading accounts with
                    regular performance reporting.
                  </p>
                </div>
                <div className="col-xl-12">
                  <div className="chart_box">
                    <img
                      src="/images/resource/wealthManagement.jpg"
                      alt="Account Handling"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InvestmentTiers;
